import { z } from 'zod'

export const MachineCreateSchema = z.object({
  code: z.string(),
  group: z.string(),
  capacityPerHour: z.number(),
  runningPrefix: z.string(),
  testingPrefix: z.string(),
})

export type MachineCreateModel = z.infer<typeof MachineCreateSchema>

export const MachineUpdateSchema = z.object({
  id: z.number(),
  code: z.string(),
  group: z.string(),
  runningPrefix: z.string(),
  testingPrefix: z.string(),
  capacityPerHour: z.number(),
})

export type MachineUpdateModel = z.infer<typeof MachineUpdateSchema>
